<template>
  <div class="modal">
    <div class="modal-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  z-index: 1000000000;
  backdrop-filter: blur(12px);
  background-color: rgba(0, 0, 0, 0.7);
  animation-name: blur;
  animation-duration: 1s;
}

.modal-content {
  max-width: 800px;
  min-width: 500px; // @dev: only applies on desktop
  background: #101010;
  display: flex;
  position: relative;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0;
  text-align: center;
  border: var(--manifold-border);
  overflow: auto;

  @media (max-width: 1024px) {
    min-width: 90%;
    max-width: 90%;
  }
}

@keyframes blur {
  from {
    backdrop-filter: blur(0);
  }

  to {
    backdrop-filter: blur(12px);
  }
}

</style>
